// Project-only breakpoints that have no equivalent in the DS responsive system.
// For 480/768/1024/1280 use `Breakpoints` from
// `@picsart/design-system/foundation/responsive` instead.
export const BREAKPOINTS = {
  tinyMobile: 360, // Small phones (e.g. iPhone SE width)
  narrow: 280, // Very narrow screens only - ensures 2 columns on all phones
} as const;
